import { API_ROUTES } from '@/api/apiRoutes';
import { log } from '@/logger/logger.ts';
import { httpReq } from '@/utils/api.utils';
import { safeAxios } from '@/services/safeAxios';

const logger = log.getLogger('workspaces');

export const approveModelLegalTerms = async (modelIds: string[]) =>
  await httpReq<{ modelIds: string[] }, void>(API_ROUTES.workspaces.modelsApprove(), { modelIds });

export const getWorkspace = async () => {
  try {
    const response = await safeAxios.get(API_ROUTES.workspaces.root());
    return response.data;
  } catch (error) {
    logger.error('Error fetching workspace:', error);
    throw error;
  }
};
